// extracted by mini-css-extract-plugin
module.exports = {"link":"image-link_link__1WZ1c","externalIcon":"image-link_externalIcon__yCLwf"};